import { useEffect } from "react";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import ListLinks from "components/ListLinks";
import { useForm } from "react-hook-form";

const SearchLinks = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
  } = useForm();

  const search_text = watch("search_text");

  return (
    <MDBox>
      <MDBox pr={1}>
        <MDInput label="Search here" {...register("search_text")} />
      </MDBox>
      <ListLinks searchText={search_text} />
    </MDBox>
  );
};

export default SearchLinks;
